import { z } from 'zod';

import { blockBaseSchema } from '../base';
import { blockCommonDataShape } from '../shared';

/**
 * An ordinary block — a stack of rows with a background and a contour. It adds
 * nothing to the shared settings; the two other subtypes are the ones that
 * specialise.
 */
export const blockDefaultDataSchema = z.object({ ...blockCommonDataShape });

export const blockDefaultSchema = blockBaseSchema.extend({
    entitySubType: z.literal('default'),
    props: blockDefaultDataSchema,
    version: z.literal(0),
});

export const blockDefaultV0Schema = blockDefaultSchema;
export type BlockDefaultV0 = z.infer<typeof blockDefaultV0Schema>;
